/**
 * The chat's Pictures needed card (spec 026): what a story turn left for the
 * author to fill, after 024's Changes bite. It links to the Pictures view's
 * Needed filter.
 */
import React from 'react';
import type { StoryTurnPictures } from '../../api/client';
import styles from './Pictures.module.scss';

/** `Jordan: talking, reassuring · Priya: talking, frustrated · Backgrounds: Kitchen`. */
export function neededGroupsLine(needed: StoryTurnPictures['needed']): string {
  const parts: string[] = [];
  const backgrounds: string[] = [];
  for (const g of needed) {
    if (g.kind === 'background') backgrounds.push(g.subject);
    else parts.push(g.variants.length ? `${g.subject}: ${g.variants.join(', ')}` : g.subject);
  }
  if (backgrounds.length) parts.push(`Backgrounds: ${backgrounds.join(', ')}`);
  return parts.join(' · ');
}

/** How many pictures the card says are still needed. */
export function neededCount(pictures: StoryTurnPictures): number {
  return Math.max(0, pictures.total - pictures.filled);
}

/** `noun` names the owner (spec 030 D-13): "scene" in a standalone scene's panel. */
export const PicturesNeededCard: React.FC<{ pictures: StoryTurnPictures; onOpen: () => void; noun?: 'story' | 'scene' }> = ({ pictures, onOpen, noun = 'story' }) => {
  const n = neededCount(pictures);
  return (
    <div className={styles.chatCard}>
      <p data-testid="pictures-card-groups">{neededGroupsLine(pictures.needed)}</p>
      <p>
        <button type="button" className={styles.link} onClick={onOpen} data-testid="pictures-card-link">
          {n === 1 ? '1 picture is still needed' : `${n} pictures are still needed`}
        </button>
        . Until they exist, those lines play the default picture or a labelled placeholder, so the {noun} already plays.
        Each one has a brief written from the scene.
      </p>
      <div>
        <button type="button" className={styles.button} onClick={onOpen} data-testid="pictures-card-open">
          See the picture map
        </button>
      </div>
    </div>
  );
};

export default PicturesNeededCard;
